const KEY = "bsk_bag";
export const SHOPIFY_HOST = "https://40mmfu-58.myshopify.com";

export const getBag = () => {
    try {
        return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
        return [];
    }
};

const save = (items) => {
    localStorage.setItem(KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent("bsk:bag"));
};

export const addToBag = (product) => {
    const bag = getBag();
    const existing = bag.find((i) => i.slug === product.slug);
    if (existing) existing.qty += 1;
    else
        bag.push({
            slug: product.slug,
            name: product.name,
            image: product.image,
            price: product.price_note,
            priceValue: product.price_value || 0,
            variantId: product.variant_id,
            qty: 1,
        });
    save(bag);
};

export const setQty = (slug, qty) => {
    let bag = getBag();
    if (qty <= 0) bag = bag.filter((i) => i.slug !== slug);
    else bag = bag.map((i) => (i.slug === slug ? { ...i, qty } : i));
    save(bag);
};

export const removeFromBag = (slug) => save(getBag().filter((i) => i.slug !== slug));

export const clearBag = () => save([]);

export const bagCount = () => getBag().reduce((a, i) => a + i.qty, 0);

export const openBag = () => window.dispatchEvent(new CustomEvent("bsk:bag:open"));

export const checkoutUrl = () => {
    const parts = getBag()
        .filter((i) => i.variantId)
        .map((i) => `${i.variantId}:${i.qty}`);
    return parts.length ? `${SHOPIFY_HOST}/cart/${parts.join(",")}` : "";
};

export const bagSubtotal = () =>
    getBag().reduce((a, i) => a + (i.priceValue || 0) * i.qty, 0);
